module.exports = __webpack_public_path__ + "media/customizations/valencia/logo-8b73ba27910df44e748826f5fab7326b.png";